var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('value-comp',{model:{value:(_vm.expr.val),callback:function ($$v) {_vm.$set(_vm.expr, "val", $$v)},expression:"expr.val"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }